import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-bootstrap/Popover';
import Overlay from 'react-bootstrap/Overlay';
import VehicleInfo from './VehicleInfo';

let defaultShow = true;

export const VehicleInfoTrigger = ({ category, placement = 'bottom' }) => {
  const [showOverlay, setShowOverlay] = useState(defaultShow);
  const overlayTarget = useRef(null);
  const categoryImageSource = require(`../../assets/category/${category}_white.png`);
  const displayOverlay = (showOverlay || defaultShow) && overlayTarget.current !== null;

  const hideOverlay = () => {
    setShowOverlay(false);
    defaultShow = false;
  }

  return (
    <div>
      <div
        className="touchable"
        onClick={() => setShowOverlay(true)}
        ref={overlayTarget}
      >
        <img
          src={categoryImageSource}
          className="vehicle-info-icon"
          alt={`${category} vehicle category`}
        />
      </div>
      <Overlay
        show={displayOverlay}
        target={overlayTarget.current}
        placement={placement}
        onHide={hideOverlay}
        rootClose
      >
        <Popover id="vehicle-info">
          <Popover.Body>
            <VehicleInfo category={category} />
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
};

VehicleInfoTrigger.propTypes = {
  category: PropTypes.string,
  placement: PropTypes.string
};

export default VehicleInfoTrigger;
